import SimpleNavigation from "@/Components/SimpleNavigation";
import SimpleNavigationMobileHeadline from "@/Components/SimpleNavigationMobileHeadline";
import { PublicRequestProvider, usePublicRequestProvider } from "@/Provider/PublicRequestProvider";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import { getPortalUrl, getCompanyHomeUrl, getHelpUrl, getRXReturnUrl } from "@/Utils/environment";

const PublicRequestLayoutContent = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { navigationHeadline, isSuccessStep, requestMasterType } = usePublicRequestProvider();

    const handleExit = () => {
        let url = getRXReturnUrl(requestMasterType != null ? requestMasterType as number : 0);
        if (url == null) url = getPortalUrl() ?? getCompanyHomeUrl();
        window.location.assign(url);
    };

    const handleHelp = () => {
        let url = getHelpUrl();
        if (url == null) url = getPortalUrl() ?? getCompanyHomeUrl();
        window.location.assign(url);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100dvh",
                width: "100%",
                maxWidth: "100%",
                overflowX: "hidden",
            }}
        >
            <SimpleNavigation
                logoOnly={isSuccessStep}
                headline={navigationHeadline}
                onExit={handleExit}
                onHelp={handleHelp}
            />
            {isMobile && !isSuccessStep && navigationHeadline && (
                <SimpleNavigationMobileHeadline headline={navigationHeadline} onExit={handleExit} />
            )}
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                    overflowY: "auto",
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export const PublicRequestLayout = () => (
    <PublicRequestProvider>
        <PublicRequestLayoutContent />
    </PublicRequestProvider>
);
